import { render, staticRenderFns } from "./OptinStatus.vue?vue&type=template&id=490a26d0&lang=pug"
import script from "./OptinStatus.vue?vue&type=script&lang=js"
export * from "./OptinStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports